import { ElementType } from 'react'

import { Box } from '../../components/Box'

import { ContentProps } from './types'

export const Content = <C extends ElementType>(props: ContentProps<C>) => (
  <Box className="promo-card__content" {...props} />
)
